import { ProjectConfigType } from '~/projects/types';

export const PROJECT_NAME = 'AI Chat';

const EmptyIcon = (): null => null;

const config: ProjectConfigType = {
  name: PROJECT_NAME,
  getLogo: () => {
    const { ReactComponent } = require('../assets/logo.svg');
    return ReactComponent;
  },
  getBigLogo: () => EmptyIcon,
  getSendIcon: () => {
    const { ReactComponent } = require('../assets/send.svg');
    return ReactComponent;
  },
  supportEmail: 'support@chatwithai.app',
  isExtensionAvailable: false,
  availableToolIds: [],
};

export default config;
